<template>
<v-app>
  <prb-toolbar v-bind:disable="!terms"></prb-toolbar>
  <prb-terms v-bind:termsDialog="!terms"></prb-terms>
  <main>
    <v-container fluid>
      <v-layout class="about__layout">
        <v-flex xs12>
          <div class="about__layout-card">
            <v-card>
              <v-card-title class="pa-0">
                <div class="top__layout-title">About</div>
              </v-card-title>
              <v-card-text>
                The Probe Miner: Objective Assessment of Chemical Probes is a community resource for the evaluation of chemical probes based on large-scale, publicly available, medicinal chemistry data. It is intended to empower researchers to select the best probes
                based on objective, data driven criteria. This resource provides evaluation of > 1.8m small molecules against for >2,200 human targets and is regularly updated in response to updates in the publicly available medicinal chemistry data.
                Our continuing data curation efforts will ensure that this resource is continually evolving and improving.
                <br/><br/> If you have identified any data that you believe are missing or require curation, please let us know [
                <a href="mailto:chemprobes@icr.ac.uk">chemprobes@icr.ac.uk</a>] to help us improve this resource for the community. Ideally, this resource should be used in conjunction with the complementary Chemical Probes Portal (<a href="http://www.chemicalprobes.org"
                target="_blank">ChemicalProbes.org</a>), which provides expert-driven chemical probe evaluation.
              </v-card-text>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </main>
  <prb-footer></prb-footer>
</v-app>
</template>

<script>
import {
  mapGetters
} from 'vuex'

import PrbToolbar from './prb-toolbar/PrbToolbar';
import PrbTerms from './prb-terms/PrbTerms';
import PrbFooter from './prb-footer/PrbFooter';

export default {
  components: {
    PrbToolbar,
    PrbTerms,
    PrbFooter
  },
  computed: mapGetters([
    'termsVerified'
  ]),
  metaInfo: {
    title: 'Probe Miner',
    titleTemplate: '%s | About'
  },
  name: 'prbabout',
  computed: {
    terms: {
      get() {
        return this.$store.state.termsVerified
      }
    }
  },
  data() {
    return {
      termsDialog: true,
      search: null,
      e1: 1
    }
  }
}
</script>

<style scoped>
.about__layout {
  height: 100%;
  background: url(../img/layer6.png) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.about__layout-card {
  padding: 5% 5% 0 5%;
}

.top__layout-title {
  width: 100%;
  font-size: 30px;
  padding: 10px;
  font-weight: 300;
  background-color: #455A64;
  color: white;
  margin: 0 0 5px 0;
}

@media screen and (max-width: 1600px) {
  .about__layout-card {
    padding: 2% 2% 0 2%;
  }
}

@media screen and (max-width: 800px) {
  .about__layout-card {
    padding: 2% 0 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// PrbAbout.vue?12b5e49a